export const ACTIONS = {
  GET_SALES_SUMMARY: 'SERVICE_DATA_VISUALIZATION__GET_SALES_SUMMARY',
  GET_SALES_CHART: 'SERVICE_DATA_VISUALIZATION__GET_SALES_CHART',

  GET_INVENTORY_LOCATIONS_CHART: 'SERVICE_DATA_VISUALIZATION__GET_INVENTORY_LOCATIONS_CHART',
  GET_INVENTORY_LOCATIONS_SUMMARY: 'SERVICE_DATA_VISUALIZATION__GET_INVENTORY_LOCATIONS_SUMMARY',
};